<template>
    <b-overlay :show="loading" rounded="sm" class="h-100">
        <Card :header="$t('dashboard.yourBestShops')" class="mb-0 h-100">
            <div class="overflow-auto">
                <ErrorMessage :value="error" />
                <b-table
                    hover
                    :items="items"
                    :fields="fields"
                    show-empty
                    :empty-text="$t('noResult')"
                    :busy="loading"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                >
                    <template #table-busy>
                        <div class="d-flex justify-content-center my-2">
                            <b-spinner />
                        </div>
                    </template>
                    <template #cell(commission)="data">
                        {{ $format.currency(data.item.commission) }}
                    </template>
                </b-table>
            </div>
        </Card>
    </b-overlay>
</template>



<script>
    import Card from '@/components/common/Card.vue';
    import ErrorMessage from '@/components/common/ErrorMessage.vue';
    import { chartDataGroupBy } from '@/utils/chart';

    export default {
        name: 'WidgetBestCampaigns',
        components: {
            Card,
            ErrorMessage,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                itemsToShow: 5,
                sortBy: 'commission',
                sortDesc: true,
                requestCampaignReport: this.parentComponent.requestCampaignReport,
            };
        },
        computed: {
            timeRange() {
                return this.parentComponent.timeRange;
            },
            fields() {
                return [
                    {
                        key: 'name',
                        label: this.$t('dashboard.campaign'),
                    },
                    {
                        key: 'commission',
                        label: this.$t('dashboard.commission'),
                        tdClass: 'text-right',
                        thClass: 'text-right',
                    },
                ];
            },
            isRoleWidgeter() {
                return this.$store.getters['auth/isRoleWidgeter'];
            },
            spaceCount() {
                return this.$store.getters['space/spaceCount'];
            },
            requestParams() {
                return {
                    startDate: this.timeRange.startDate,
                    endDate: this.timeRange.endDate,
                    feature: 'publisher_commission',
                    groupBy: chartDataGroupBy(this.timeRange),
                    showFirst: this.itemsToShow,
                };
            },
            apiParams() {
                return { requestParams: this.requestParams };
            },
            loading() {
                return this.requestCampaignReport.getLoading();
            },
            campaigns() {
                return this.requestCampaignReport.getData()?.pie_chart || [];
            },
            items() {
                return this.campaigns.slice(0, this.itemsToShow).map(item => ({ name: item[0], commission: item[1] })) || [];
            },
            error() {
                return this.requestCampaignReport.getError();
            },
        },
        watch: {
            apiParams: {
                handler: 'fetchData',
            },
        },
        methods: {
            fetchData(params = {}) {
                if (this.isRoleWidgeter && !this.spaceCount) return;
                this.requestCampaignReport.get({ ...this.apiParams, ...params });
            },
        },
        created() {
            this.fetchData();
        },
    };
</script>
